(() => {
  const root = document.querySelector('[data-ledumi]');
  if (!root) return;
  const format = (cents) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: window.Shopify?.currency?.active || 'PLN' }).format(cents / 100);
  let quantity = 2;
  const variantInput = root.querySelector('[data-variant-select]');
  const activeVariant = () => {
    if (variantInput?.tagName === 'SELECT') return variantInput.options[variantInput.selectedIndex];
    return variantInput;
  };
  const update = () => {
    const option = activeVariant();
    const price = Number(option?.dataset.price || 0);
    const compare = Number(option?.dataset.compare || 0);
    const discount = quantity === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
    const total = Math.max(0, price * quantity - discount);
    root.querySelectorAll('[data-price-for]').forEach((node) => {
      const qty = Number(node.dataset.priceFor);
      const bundleDiscount = qty === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
      node.textContent = format(Math.max(0, price * qty - bundleDiscount));
    });
    root.querySelectorAll('[data-compare-for]').forEach((node) => {
      const qty = Number(node.dataset.compareFor);
      const compareTotal = compare * qty;
      const bundleDiscount = qty === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
      const saleTotal = Math.max(0, price * qty - bundleDiscount);
      node.textContent = compareTotal > saleTotal ? format(compareTotal) : '';
      node.hidden = compareTotal <= saleTotal;
    });
    root.querySelector('[data-total]').textContent = format(total);
    root.querySelectorAll('[data-mobile-total]').forEach((node) => { node.textContent = format(total); });
    const del = root.querySelector('[data-compare]');
    del.textContent = compare * quantity > total ? format(compare * quantity) : '';
    del.hidden = compare * quantity <= total;
  };
  root.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
    quantity = Number(button.dataset.qty);
    root.querySelectorAll('[data-qty]').forEach((item) => {
      item.classList.toggle('selected', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    update();
  }));
  variantInput?.addEventListener('change', update);
  root.querySelectorAll('[data-thumb]').forEach((button) => button.addEventListener('click', () => {
    root.querySelector('[data-main-image]').src = button.dataset.thumb;
    root.querySelectorAll('[data-thumb]').forEach((item) => item.classList.toggle('active', item === button));
  }));
  const drawer = root.querySelector('[data-drawer]');
  const overlay = root.querySelector('[data-overlay]');
  const close = () => { drawer.classList.remove('open'); overlay.classList.remove('open'); };
  const openCart = async () => {
    drawer.classList.add('open'); overlay.classList.add('open');
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await response.json();
    const lines = root.querySelector('[data-cart-lines]'); lines.replaceChildren();
    cart.items.forEach((item) => {
      const row = document.createElement('div'); row.className = 'drawer-line';
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; row.append(img); }
      const text = document.createElement('span'); text.textContent = `${item.product_title} × ${item.quantity}`; row.append(text); lines.append(row);
    });
    root.querySelector('[data-cart-total]').textContent = format(cart.total_price);
    root.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
  };
  root.querySelector('[data-cart-open]')?.addEventListener('click', openCart);
  root.querySelector('[data-cart-close]')?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  root.querySelectorAll('[data-add]').forEach((addButton) => addButton.addEventListener('click', async (event) => {
    const button = event.currentTarget; button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(activeVariant().value), quantity }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Nie udało się dodać produktu.');
      await openCart();
    } catch (error) { window.alert(error.message); } finally { button.disabled = false; }
  }));
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealTargets = root.querySelectorAll('.hero-photo, .buybox, .moments, .guarantee, .steps, .split, .formats, .faq, .final-cta');
    revealTargets.forEach((element) => element.classList.add('scroll-reveal'));
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealTargets.forEach((element) => revealObserver.observe(element));
  }
  update();
})();
